(function () {
  'use strict';

  function updatePlayButton(video, button) {
    if (!video || !button) return;
    var paused = video.paused || video.ended;
    button.classList.toggle('is-paused', paused);
    button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
  }

  function updateMuteButton(video, button) {
    if (!video || !button) return;
    var muted = video.muted || video.volume === 0;
    button.classList.toggle('is-muted', muted);
    button.setAttribute('aria-label', muted ? 'Unmute video' : 'Mute video');
  }

  function setupMedia(container) {
    if (!container || container.dataset.sstVideoInit === '1') return;
    var video = container.querySelector('video');
    var iframe = container.querySelector('iframe');
    var controls = container.querySelector('.sst-video__controls');
    var playButton = container.querySelector('[data-sst-video-play]');
    var muteButton = container.querySelector('[data-sst-video-mute]');

    if ((!video && !iframe) || !controls || !playButton || !muteButton) return;

    container.dataset.sstVideoInit = '1';
    controls.hidden = false;

    if (video) {
      video.controls = false;
      video.muted = true;
      video.playsInline = true;

      updatePlayButton(video, playButton);
      updateMuteButton(video, muteButton);

      playButton.addEventListener('click', function () {
        if (video.paused || video.ended) {
          video.play().catch(function () {});
        } else {
          video.pause();
        }
      });

      muteButton.addEventListener('click', function () {
        video.muted = !video.muted;
        if (!video.muted && video.volume === 0) video.volume = 1;
        updateMuteButton(video, muteButton);
      });

      video.addEventListener('play', function () { updatePlayButton(video, playButton); });
      video.addEventListener('pause', function () { updatePlayButton(video, playButton); });
      video.addEventListener('ended', function () { updatePlayButton(video, playButton); });
      video.addEventListener('volumechange', function () { updateMuteButton(video, muteButton); });
      return;
    }

    var isPaused = false;
    var isMuted = true;
    playButton.classList.remove('is-paused');
    muteButton.classList.add('is-muted');

    function postYoutube(command) {
      iframe.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func: command, args: '' }),
        '*'
      );
    }

    function postVimeo(method, value) {
      var message = { method: method };
      if (typeof value !== 'undefined') message.value = value;
      iframe.contentWindow.postMessage(JSON.stringify(message), '*');
    }

    function isVimeo() {
      return iframe.classList.contains('js-vimeo') || iframe.src.indexOf('vimeo.com') !== -1;
    }

    playButton.addEventListener('click', function () {
      isPaused = !isPaused;
      if (isVimeo()) {
        postVimeo(isPaused ? 'pause' : 'play');
      } else {
        postYoutube(isPaused ? 'pauseVideo' : 'playVideo');
      }
      playButton.classList.toggle('is-paused', isPaused);
      playButton.setAttribute('aria-label', isPaused ? 'Play video' : 'Pause video');
    });

    muteButton.addEventListener('click', function () {
      isMuted = !isMuted;
      if (isVimeo()) {
        postVimeo('setVolume', isMuted ? 0 : 1);
      } else {
        postYoutube(isMuted ? 'mute' : 'unMute');
      }
      muteButton.classList.toggle('is-muted', isMuted);
      muteButton.setAttribute('aria-label', isMuted ? 'Unmute video' : 'Mute video');
    });
  }

  function watchDeferredMedia(media) {
    if (!media || media.dataset.sstVideoWatch === '1') return;
    media.dataset.sstVideoWatch = '1';

    var poster = media.querySelector('.sst-video__poster');
    if (poster) {
      poster.addEventListener('click', function () {
        window.setTimeout(function () { setupMedia(media); }, 0);
      });
    }

    var observer = new MutationObserver(function () { setupMedia(media); });
    observer.observe(media, { childList: true });
    setupMedia(media);
  }

  function init() {
    document.querySelectorAll('.sst-video-section .video-section__media').forEach(watchDeferredMedia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
